import { BaseApiClient } from '../client'
import type { CreatorNote } from '../types'

export class CreatorNotesApi extends BaseApiClient {
  async list(creatorId: string): Promise<CreatorNote[]> {
    return this.request(`/api/admin/creators/${creatorId}/notes`)
  }

  async create(creatorId: string, text: string): Promise<CreatorNote> {
    return this.request(`/api/admin/creators/${creatorId}/notes`, {
      method: 'POST',
      body: JSON.stringify({ text }),
    })
  }

  async delete(creatorId: string, noteId: string): Promise<void> {
    return this.request(`/api/admin/creators/${creatorId}/notes/${noteId}`, {
      method: 'DELETE',
    })
  }
}
